export default {
  title: 'Fanhan platform',
  project: 'Project',
  help: 'Help',
  register: 'Register',
  login: 'Log in',
  logout: 'Log out',
  workbench: 'Workbench',
  team: 'Team',
  ucenter: '	Personal center',
  notHaveAccount: 'No account?',
  haveAccount: 'Already have an account',
  bulletinBoard: 'Bulletin board',
  China: 'China',
  otherCountries: 'Foreign',
  js: {
    success: 'Success'
  },
  discover: 'Discover'
}



// WEBPACK FOOTER //
// ./src/lang/en/navbar.js